export default {
    ASMA: 1,
    DESNUTRICAO: 2,
    DIABETES: 3,
    DPOC: 4,
    HIPERTENSAO: 5,
    OBESIDADE: 6,
    PRE_NATAL: 7,
    PUERICULTURA: 8,
    PUERPERIO: 9,
    REABILITACAO: 10,
    SAUDE_MENTAL: 11,
    SAUDE_SEXUAL: 12,
    TABAGISMO: 13,
    USUARIO_ALCOOL: 14,
    OUTRAS_DROGAS: 15,
}